import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend } from 'chart.js';
import { useTranslation } from 'react-i18next';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend);

interface RevenueChartProps {
  totalRevenue: number;
  averageOrderValue: number;
}

export const RevenueChart: React.FC<RevenueChartProps> = ({ totalRevenue, averageOrderValue }) => {
  const { t } = useTranslation();

  // Mock data for demonstration - in real app, this would come from API
  const mockMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'];
  const mockRevenue = [
    totalRevenue * 0.1,
    totalRevenue * 0.15,
    totalRevenue * 0.12,
    totalRevenue * 0.18,
    totalRevenue * 0.22,
    totalRevenue * 0.23,
  ];

  const chartData = {
    labels: mockMonths,
    datasets: [
      {
        label: t('dashboard:revenue'),
        data: mockRevenue,
        borderColor: '#10b981',
        backgroundColor: 'rgba(16, 185, 129, 0.1)',
        borderWidth: 2,
        fill: true,
        tension: 0.4,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
    <div className="chart-container">
      <h3>{t('dashboard:revenueOverTime')}</h3>
      <Line data={chartData} options={options} />
    </div>
  );
};

